<template>
  <router-view />
</template>

<script>
export default {
  name: 'SettingsIndex'
}
</script>
